module.exports = __webpack_public_path__ + "img/IFEA-Treuhand-GmbH-LOGO-STACKED-blue-background.a506f588.png";